import MultiDistrict from './MultiDistrict';

export default MultiDistrict;
